import React, { useEffect, useState } from "react"
import Header from "../../component/Header";
import classes from "./style.module.scss"
import { FormProvider, useForm } from "react-hook-form";
import InputBox from "../../component/InputBox";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import TextEditor from "./components/textEditor";
import UploadBox from "./components/uploadBox";
import request from "../../service";
import Exported from "../../service/endpoints";
import FileUpload from '../../component/FileUpload';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { convert } from "html-to-text";
import { ContentState, convertFromHTML, convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { Toast } from "../../service/toast";
import { convertHTMLToDraft } from "../../helpers";
import { stateToHTML } from "draft-js-export-html";

const ManageContent = () => {
    const [editorContent, setEditorContent] = useState("");
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [isEditContent, setIsEditContent] = useState(false)
    const aboutData = ["About Us", "Privacy & Security", "Terms & Conditions"];
    const [activeTab, setActiveTab] = useState("About Us")
    const [getContentValue, setGetContentValue] = useState([])
    const [onSaveRequest, setOnSaveRequest] = useState(false);
    const formMethods = useForm({
        mode: "onSubmit",
    });
    const activeStatus = activeTab === "About Us" ? 1 : activeTab === "Privacy & Security" ? 2 : activeTab === "Terms & Conditions" ? 3 : null
    const {
        handleSubmit,
        formState: { errors },
        trigger,
        register,
        setValue,
    } = formMethods;

    const handleSave = () => {
        const contentState = editorState.getCurrentContent();
        const html = stateToHTML(contentState);
        const newJson = convertHTMLToDraft(html)
        setEditorContent(newJson);
    };

    const onSubmit = async (data) => {
        setTimeout(() => {
            handleSave()
        }, 300)
        setOnSaveRequest(true)
        const contentState = editorState.getCurrentContent();
        const html = stateToHTML(contentState);

        const requestData = {
            title: data.title || "",
            content_type_id: activeStatus,
            description: html,
        };

        const isEdit = getContentValue.length > 0;
        const apiUrl = isEdit ? `${Exported.Endpoints.content}?content_id=${activeStatus}` : `${Exported.Endpoints.content}`;
        const apiMethod = isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST;
        request({
            url: apiUrl,
            method: apiMethod,
            data: requestData,
        })
            .then((res) => {
                console.log(res, "res");
                Toast({
                    type: 'success',
                    message: 'Data updated successfully'
                })
            })
            .catch((err) => {
                console.error("Error saving content:", err);
                Toast({
                    type: 'error',
                    message: 'Unable to process the request!..'
                })
            });
    }

    const getContentValues = async () => {
        try {
            const response = await request({
                url: `${Exported.Endpoints.content}?content_type=${activeStatus}`,
                method: Exported.APIMethods.GET,
            });
            const content = response?.data?.data?.description || "";
            const title = response?.data?.data?.title || "";

            if (response?.data?.data) {
                setValue("title", title);
                setGetContentValue([
                    {
                        title,
                        description: content,
                    },
                ]);
                const editorContentJSON = convertHTMLToDraft(content);
                setEditorContent(editorContentJSON);
                setIsEditContent(true);

            } else {
                setGetContentValue([]);
                setValue("title", "");
                setEditorContent("");
            }
        } catch (error) {
            console.error("Error fetching content:", error);
            setGetContentValue([]);
            setIsEditContent(false);
            setValue("title", "");
            setEditorContent("");
        }
    };


    useEffect(() => {
        getContentValues()
    }, [activeTab])

    const handleOpenExternal = () => {
        window.open(`/${activeTab === "About Us" ? "about-us" : activeTab === "Privacy & Security" ? "privacy-and-security" : activeTab === "Terms & Conditions" ? "terms-and-conditions" : null}`, "_blank", "noopener,noreferrer");
    };

    return (
        <div>
            <div className=" flex justify-between">
                <Header isHeader header={"Manage Content"} />
                <a href={`/about-us`} target="_blank" >
                    <Button smallBtn text={`View ${activeTab}`} onClick={handleOpenExternal} />
                </a>
            </div>
            <div className={`${classes.userHeaderList} w-[100%] flex items-center`}>
                {aboutData.map((item) => (<div className={`${classes.userTab} ${activeTab === item ? classes.activeTab : ''}`} onClick={() => setActiveTab(item)}>{item}</div>))}
            </div>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${classes.createRoleAdminWrapper}`}>
                        <div className={`${classes.formGroup} mt-5`}>
                            <div className={`${classes.formField}`}>
                                <InputBox
                                    label={"Title"}
                                    className={`w-[100%]`}
                                    isEdit={isEditContent}
                                    name={"title"}
                                    placeholder={'Title'}
                                    {...register("title", {
                                        required: true,
                                    })}
                                    error={errors.title}
                                    messages={{
                                        required: "Name is required",
                                    }}
                                />
                            </div>
                        </div>
                        <div className={`${classes.textEditor}`}>
                            <TextEditor handleSave={handleSave}
                                value={editorContent}
                                editorState={editorState}
                                setEditorState={setEditorState} />
                        </div>
                    </div>
                    <div className={`flex justify-end mb-3`}>
                        <Button text={"Save"} className={'!w-[140px]'} smallBtn />
                    </div>
                </form>
            </FormProvider>


        </div>
    )
}

export default ManageContent